import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {
  @Input() data: Array<any>=[];

  constructor() { }

  ngOnInit(): void {
    console.log(this.data);
  }

}
